export default "__VITE_ASSET__oxS4QGGh__"